// SWEDISH
export const locale = {
    login: {
        title: "Välkommen tillbaka",
        emailLabel: "E-post",
        emailValidationError: "E-post krävs och en giltig e-postadress.",
        passwordLabel: "Lösenord",
        passwordValidationError: "Lösenord krävs.",
        keepMeLabel: "Håll mig inloggad",
        forgotPassword: "Glömt ditt lösenord ?",
        loginBtn: "Logga in",
        dontHaveAccount: "Har du inte ett konto?",
        signUp: "Bli Medlem",
    },
    forgotPassword: {
        title: "Glömt ditt lösenord?",
        emailInput: {
            label: "E-post",
            description:
                "Ange din e-postadress för att få återställningslösenordslänken",
        },
        submitBtn: "Skicka",
    },
    resetPassword: {
        title: "Återställ lösenord",
        passwordInput: {
            label: "Nytt lösenord",
        },
        passwordConfirmationInput: {
            label: "Bekräfta nytt lösenord",
        },
        submitBtn: "Återställ lösenord",
    },
    menu: {
        calendar: "Kalender",
        clients: "Kunder",
        services: "Tjänster",
        staff: "Personal",
        statistics: "Statistik",
        settings: "Inställningar",
        profile: "Profil",
        contactSupport: "Kontakta supporten",
        logout: "Logga ut",
    },
    calendar: {
        title: "Kalender",
        alert: {
            title: "Välkommen till din kalender",
            text: "Möten som kunder eller du bokar visas här. Klicka på ett möte för att se detaljerna och hantera den.",
        },
        newEventActions: {
            appointment: "Ny bokning",
            appointmentMobile: "Ny bokning",
            blockTime: "Blockera tid",
            close: "Stäng",
        },
        appointment: {
            cancelAppointment: "Avbryt mötet",
            editAppointment: "Redigera mötet",
            notesLabel: "Anteckningar",
            noNotesText: "Inga anteckningar för detta möte",
        },
        blockTime: {
            removeBlockTime: "Ta bort blockeringstiden",
            editBlockTime: "Redigera blockeringstid",
        },
    },
    calendarFilters: {
        placeFilter: {
            createPlace: "Skapa ny plats",
        },
        staffFilter: {
            allStaff: "All personal",
            createStaff: "Skapa ny personal",
        },
        viewFilter: {
            week: "vecka",
            day: "dag",
        },
        mobileViewFilter: {
            title: "Kalendervy",
            day: "Dag",
            threeDays: "3 Dagar",
        },
        mobilePlaceAndStaffFilter: {
            title: "Filtrera",
            placesLabel: "Platser",
            staffLabel: "Personal",
            allStaffLabel: "All personal",
        },
    },
    appointmentForm: {
        createTitle: "Ny bokning",
        editTitle: "Redigera mötet",
        createSubmitBtn: "Skapa bokning",
        editSubmitBtn: "Spara",
        noDateLabel: "Lägg till datum",
        clientInput: {
            label: "Kund",
            placeholder: "Lägg till en kund",
            searchPlaceholder: "Sök kund",
            noResultsText: "Ingen kund tillgänglig",
            editBtn: "redigera detaljer",
            removeBtn: "ta bort från bokning",
            createBtn: "Skapa ny kund",
            details: {
                title: "Kundinformation",
                emailLabel: "E-post",
                phoneLabel: "Telefonnummer",
                notesLabel: "Anteckningar",
            },
        },
        serviceInput: {
            label: "Tjänst",
            placeholder: "Lägg till en tjänst",
            searchPlaceholder: "Sök efter service",
            noResultsText: "Ingen tjänst tillgänglig",
            createBtn: "Skapa ny tjänst",
        },
        staffInput: {
            label: "Personal",
            placeholder: "Välj personal",
            searchPlaceholder: "Sök personal",
            noResultsText: "Ingen personal tillgänglig",
            createBtn: "Skapa ny personal",
        },
        startTimeInput: {
            label: "Starttid",
            placeholder: "Välj en tid",
            noResultsText: "Ingen ledig plats",
        },
        durationLabel: "Längd",
        notesInput: {
            label: "Anteckning",
            placeholder: "Lägg till anteckning (endast synlig för personal)",
        },
    },
    blockTimeForm: {
        title: "Blockera tid",
        createSubmitBtn: "Skapa blockerad tid",
        editSubmitBtn: "Redigera blockerad tid",
        dateLabel: "Lägg till datum",
        staffInput: {
            label: "Personal",
            placeholder: "Välj personal",
            searchPlaceholder: "Sök personal",
            noResultsText: "Ingen personal tillgänglig",
            createBtn: "Skapa ny personal",
        },
        startTimeInput: {
            label: "Starttid",
            placeholder: "Starttid",
            noResultsText: "Ingen ledig plats",
        },
        endTimeInput: {
            label: "Sluttid",
            placeholder: "Sluttid",
            noResultsText: "Ingen ledig plats",
        },
        notesInput: {
            label: "Beskrivning",
            placeholder: "T.ex. Lunchmöte",
        },
    },
    dateInput: {
        appointmentTitle: "Utnämningsdagen",
        blockTimeTitle: "Välj datum",
        mobileTitle: "Välj datum",
        saveBtn: "Spara",
    },
    calendarForm: {
        createTitle: "Ny personal",
        editTitle: "Redigera personal",
        saveBtn: "Spara",
        cancelBtn: "Avbryt",
        mobileButtons: {
            sendResetPassword: "Skicka e-post för återställningslösenord",
            delete: "Ta bort personal",
            close: "Stänga",
        },
        basicSettings: {
            title: "Grundinställningar",
            profilePictureInput: {
                label: "Profilbild (valfritt, men rekommenderas starkt)",
                description: "Det här fotot kommer att visas på din profilsida",
                mobileLabel: "Profilbild",
                mobileDescription: "(valfritt, men rekommenderas starkt)",
                uploadBtn: "Ladda upp profilbild",
                deleteBtn: "Radera",
            },
            nameInput: {
                label: "Namn",
                placeholder: "T.ex. Linda",
            },
            titleInput: {
                label: "Titel",
                placeholder: "T.ex. Hårstylist",
            },
            personalDetails: {
                label: "Personliga detaljer",
                description:
                    "Denna information används endast för intern kommunikation och aviseringar.",
            },
            firstNameInput: {
                label: "Förnamn",
            },
            lastNameInput: {
                label: "Efternamn",
            },
            emailInput: {
                label: "E-post",
            },
            phoneInput: {
                label: "Telefonnummer",
            },
            roleInput: {
                label: "Behörighet",
                manageAccountLabel: "Hantera konto",
                managePlaceLabel: "Hantera plats",
                manageBookingsLabel: "Hantera bokningar för plats",
                manageCalendarLabel: "Hantera egen kalender",
            },
        },
        availability: {
            title: "Tillgänglighet",
            description:
                "Välj mellan vilken tid klienter kan boka tjänster i den här kalendern",
            editBtn: "Redigera",
            removeBtn: "Ta bort",
            addDayOffBtn: "+ Lägg till specifik ledig dag",
            closedLabel: "Stängd",
        },
        placeAndServices: {
            title: "Plats och tjänster",
            placeInput: {
                label: "Vilken plats tillhör kalendern?",
            },
            servicesInput: {
                label: "Vilka tjänster kan bokas med den här kalendern?",
            },
            assignedServicesIntro:
                "För varje tilldelad tjänst kan du öppna Avancerade inställningar för att hantera ett valfritt foto.",
            serviceAdvanced: {
                title: "Avancerade inställningar",
                photoSaveFirstHint:
                    "Spara den här medarbetaren först för att ladda upp eller ta bort foton för varje tjänst.",
                photoLabel: "Tjänstfoto",
                photoHint:
                    "JPEG, PNG eller WebP, max 2 MB. Bilden sparas så fort du väljer en fil.",
                uploadBtn: "Ladda upp foto",
                deleteBtn: "Ta bort",
                uploading: "Laddar upp…",
                invalidType: "Välj en JPEG-, PNG- eller WebP-bild.",
                fileTooLarge: "Bilden får vara högst 2 MB.",
                uploadFailed: "Det gick inte att ladda upp fotot.",
                deleteFailed: "Det gick inte att ta bort fotot.",
            },
        },
        advancedSettings: {
            title: "Avancerade inställningar",
            requiredInfoInput: {
                label: "Vilken information krävs av klienten när de bokar?",
                firstNameLabel: "Förnamn",
                lastNameLabel: "Efternamn",
                emailLabel: "E-post",
                phoneLabel: "Telefonnummer",
                addressLabel: "Adress",
                zipCodeLabel: "Postnummer",
                cityLabel: "Stad",
                otherLabel: "Annat",
            },
            otherInput: {
                label: 'Alias ​​för "Annat"',
                placeholder: "Annat",
            },
            cancellationMarginInput: {
                label: "Avbokningsmarginal",
                description:
                    "Tills hur länge innan bokningen är det möjligt att avboka?",
                daysLabel: "dagar",
                hoursLabel: "timmar",
                minutesLabel: "minuter",
            },
            bookingMarginInput: {
                label: "Bokningsmarginal",
                description:
                    "Hur nära en tillgänglig tid är det möjligt att boka?",
                daysLabel: "dagar",
                hoursLabel: "timmar",
                minutesLabel: "minuter",
            },
            tocInput: {
                label: "Allmänna villkor (valfritt)",
                description:
                    "Om du lägger till villkor måste kunder acceptera dem genom att läsa och markera en ruta för att skapa en bokning.",
            },
        },
        notifications: {
            title: "Meddelanden",
            toServiceProviderInput: {
                label: "Till tjänsteleverantören",
                description:
                    'Meddelanden kommer att skickas till e-post som anges i "Personliga detaljer"',
                bookingConfirmationLabel: "Bokningsbekräftelse",
                cancellationConfirmationLabel: "Avbokningsbekräftelse",
            },
            toCustomerInput: {
                label: "Till kunden",
                description:
                    "Meddelanden kommer att skickas till den e-post som tillhandahålls av kunden",
                bookingConfirmationLabel: "Bokningsbekräftelse",
                cancellationConfirmationLabel: "Avbokningsbekräftelse",
                reminderLabel: "Påminnelse om bokning",
                followUpLabel: "Uppföljning",
            },
            followUpInput: {
                label: "Uppföljning",
                description:
                    "Öka chansen för återkommande bokningar genom automatiserad uppföljning",
                daysLabel: "dagar efter bokad tid",
            },
        },
    },
    clients: {
        title: "Kunder",
        searchInput: {
            placeholder: "Sök efter namn, e-post eller telefonnummer",
        },
        createClientBtn: "Ny kund",
        clientDropdown: {
            showBtn: "Se profil",
            editBtn: "Redigera detaljer",
            deleteBtn: "Ta bort kund",
        },
        table: {
            columns: {
                name: "Namn",
                phone: "Telefonnummer",
                email: "E-post",
            },
            pagination: {
                show: "Som visar",
                of: "av",
            },
        },
        mobileSearchInput: {
            placeholder: "Sök efter kund",
        },
    },
    clientProfile: {
        title: "Kundprofil",
        createAppointmentBtn: "Ny bokning",
        dropdown: {
            editBtn: "Redigera detaljer",
            deleteBtn: "Ta bort kund",
        },
        infoCard: {
            email: {
                label: "E-post",
            },
            phone: {
                label: "Telefonnummer",
            },
            notes: {
                label: "Anteckningar",
            },
            notifications: {
                label: "Notifikationer",
                enabledLabel: "Aktiverad",
                disabledLabel: "Inaktiverad",
            },
        },
        salesCard: {
            title: "Total försäljning",
            bookings: {
                all: "Alla bokningar",
                completed: "Avslutade",
                canceled: "Avbokade",
            },
        },
        mobileButtons: {
            editBtn: "Redigera detaljer",
            deleteBtn: "Ta bort kund",
            closeBtn: "Stänga",
        },
    },
    appointmentList: {
        title: "Tidigare möten",
        noAppointmentsLabel: "Inga tidigare bokningar",
    },
    clientForm: {
        createTitle: "Skapa ny kund",
        editTitle: "Redigera kund",
        saveBtn: "Spara",
        cancelBtn: "Avbryt",
        contactDetails: {
            title: "Kontaktuppgifter",
            firstNameInput: {
                label: "Förnamn",
            },
            lastNameInput: {
                label: "Efternamn",
            },
            emailInput: {
                label: "E-post",
            },
            phoneInput: {
                label: "Telefonnummer",
            },
            notificationsInput: {
                label: "Notifikationer",
                description:
                    "Notifikationer kommer att skickas till e-postmeddelandet ovan",
                notificationsLabel: "Notifikationer",
            },
        },
        aditionalInfo: {
            title: "Ytterligare information (valfritt)",
            addressInput: {
                label: "Adress",
            },
            cityInput: {
                label: "Stad",
            },
            zipCodeInput: {
                label: "Postnummer",
            },
            notesInput: {
                label: "Anteckningar",
                placeholder: "T.ex. Allergisk mot nitrilhandskar",
            },
        },
    },
    services: {
        title: "Tjänster",
        createServiceBtn: "Lägg till ny",
        createCategoryBtn: "Lägg till ny",
        table: {
            dropdown: {
                createServiceBtn: "Lägg till ny tjänst",
                editCategoryNameBtn: "Redigera kategorinamn",
                editCategoryImageBtn: "Redigera bild",
                deleteCategoryBtn: "Ta bort kategori",
            },
            editBtn: "Redigera",
            minutesLabel: "minuter",
        },
        mobileButtons: {
            createServiceBtn: "Lägg till ny tjänst",
            editCategoryNameBtn: "Redigera kategorinamn",
            deleteCategoryBtn: "Ta bort kategori",
            closeBtn: "Stänga",
        },
        tableFilter: {
            services: "Tjänster",
            categories: "Kategorier",
        },
        createCategoryModal: {
            title: "Lägg till kategori",
            nameInput: {
                label: "Kategorinamn",
                placeholder: "T.ex. Hårborttagning",
            },
            imageInput: {
                label: "Kategoribild (valfritt)",
                uploadBtn: "Ladda upp bild",
                removeBtn: "Ta bort",
            },
            cancelBtn: "Avbryt",
            saveBtn: "Spara",
        },
        editCategoryImageModal: {
            title: "Redigera kategoribild",
            uploadBtn: "Ladda upp bild",
            removeBtn: "Ta bort",
            saveBtn: "Spara",
            cancelBtn: "Avbryt",
        },
    },
    mobileServicesFilter: {
        title: "Filtrera",
        services: "Tjänster",
        categories: "Kategorier",
    },
    serviceForm: {
        createTitle: "Lägg till tjänst",
        editTitle: "Redigera tjänst",
        cancelBtn: "Avbryt",
        saveBtn: "Spara",
        deleteBtn: "Radera",
        nameInput: {
            label: "Tjänstens namn",
            placeholder: "T.ex. Damklippning eller Helkroppsmassage",
        },
        categoryInput: {
            label: "Kategori",
            description:
                "Tjänsten placeras i denna kategori på din offentliga profil",
            placeholder:
                "Lägg till en kategori genom att skriva eller välj från föregående",
        },
        descriptionInput: {
            label: "Beskrivning (valfritt)",
            placeholder: "T.ex. En kvinnas frisyr inklusive tvätt och tork",
        },
        priceInput: {
            label: "Pris",
            showPublicLabel: "Synlig",
        },
        durationInput: {
            label: "Längd (minuter)",
            showPublicLabel: "Synlig",
        },
        serviceTypeInput: {
            label: "Typ av service",
            description: "Låt sökmotorn ge kunderna mer exakta resultat",
        },
        sameTimePeopleInput: {
            label: "Antal personer som kan boka samtidigt",
            description: "T.ex. 20 personer kan boka yogasession",
            inputLabel: "människor",
            toggleBtn: "+ Låt fler personer boka samtidigt",
        },
        breakInput: {
            label: "Paus efter bokning av denna tjänst",
            description:
                "Ingen kan boka så många minuter efter att ha avslutat denna tjänst",
            inputLabel: "minuter",
            toggleBtn: "+ Lägg till en paus efter tjänst",
        },
    },
    staff: {
        title: "Personal",
        createStaffBtn: "Ny personal",
        table: {
            columns: {
                name: "Namn",
                phone: "Telefonnummer",
                email: "E-post",
            },
            dropdown: {
                editBtn: "Redigera detaljer",
                deleteBtn: "Ta bort personal",
            },
            pagination: {
                show: "Som visar",
                of: "av",
            },
        },
    },
    mobileStaffFilter: {
        title: "Filtrera",
        placesLabel: "Platser",
    },
    statistics: {
        title: "Statistik",
        totalSalesLabel: "Total rea",
        totalAppointmentsLabel: "Totala möten",
        completedAppointmentsLabel: "Avslutad möten",
        canceledAppointmentsLabel: "Inställt möten",
        staffSalesLabel: "Försäljning av personal",
        noDataLabel: "Inga tillgängliga data",
        allTimeLabel: "hela perioden",
        currencyLabel: "sek",
        topServicesCard: {
            title: "Bästsäljande tjänster",
            serviceNameLabel: "Service namn",
            totalSalesLabel: "Total rea (sek)",
        },
        charts: {
            currentIncomeLabel: "Nuvarande inkomst",
            currentAppointmentsLabel: "Nuvarande möten",
            pastYearLabel: "Förra året",
        },
    },
    statisticsFilters: {
        placeFilter: {
            allLocationsLabel: "Alla platser",
        },
        periodFilter: {
            dayLabel: "Dag",
            monthLabel: "Månad",
            yearLabel: "År",
        },
        mobilePlaceFilter: {
            title: "Filtrera",
            allLocationsLabel: "Alla platser",
        },
        mobilePeriodFilter: {
            title: "Välj datum",
        },
    },
    settings: {
        title: "Inställningar",
        tabs: {
            widget: "Widgetinställningar",
            account: "Kontoinställningar",
            locations: "Platser",
            billing: "Fakturering",
        },
        mobileTabsSelect: {
            widget: {
                title: "Widgetinställningar",
                description: "Anpassa din widget.",
            },
            account: {
                title: "Kontoinställningar",
                description:
                    "Hantera inställningar som din företagsinformation och online-länkar.",
            },
            locations: {
                title: "Platser",
                description: "Hantera flera platser för ditt företag.",
            },
            billing: {
                title: "Fakturering",
                description:
                    "Hantera din plan, betalningsmetod och se faktureringshistorik.",
            },
        },
    },
    widgetTab: {
        previewBtn: "Förhandsgranska widget",
        saveBtn: "Spara",
        backBtn: "Tillbaka till widgetinställningar",
        appearance: {
            title: "Utseende",
            logoInput: {
                label: "Företagslogotyp:",
                description: "Ladda upp",
            },
            colorInput: {
                label: "Bakgrundsfärg:",
            },
            statusInput: {
                label: "Status:",
            },
            messageInput: {
                label: "Meddelande:",
            },
            showReviewsInput: {
                label: "Visa recensioner:",
            },
        },
        installation: {
            title: "Installation",
            description:
                "Det verkar som om du inte har installerat chattkoden än. Välj bland en av installationsguiderna nedan:",
            jsCard: {
                instructions: {
                    step1: "Klistra in denna koden precis innan </body> taggen stängs",
                },
                copyBtn: "Kopiera",
                needHelpLabel: "Behöver du hjälp?",
                contactUsLabel: "Kontakta oss.",
            },
            wpCard: {
                instructions: {
                    step1: "Logga in på din WordPress admin panel",
                    step2: "Gå till Appearance > Theme Editor",
                    step3: "Under Theme Files (till höger), klicka på “Theme Footer” (footer.php)",
                    step4: "Klistra in din din Bookybook kod innan </body> taggen längre ner",
                    step5: "Klicka på “Update file” för att spara ändringa",
                },
                copyBtn: "Kopiera",
                needHelpLabel: "Behöver du hjälp?",
                contactUsLabel: "Kontakta oss.",
            },
        },
        widget: {
            startBookingLabel: "Starta en bokning",
            nextFreeTimeLabel: "Nästa lediga tid från",
            bookingBtn: "Boka en tid med oss",
            reviewsLabel: "Detta säger våra kunder om oss",
            poweredByLabel: "Powered by",
        },
    },
    accountTab: {
        guide: {
            businessInfo: {
                title: "Företagsinformation",
                description:
                    "Denna information används endast för intern kommunikation. Det kommer inte att visas i din profil.",
            },
            onlineLinks: {
                title: "Online-länkar",
                description:
                    "Lägg till företagets webbplats och länkar till sociala medier för delning med kunder",
            },
        },
        companyDetailsCard: {
            title: "Företagsinformation",
            nameInput: {
                label: "Företagsnamn",
            },
            organisationNumberInput: {
                label: "Svenskt organisationsnummer",
            },
            addressInput: {
                label: "Adress",
            },
            postalNumberInput: {
                label: "Postnummer",
            },
            cityInput: {
                label: "Stad",
            },
            emailInput: {
                label: "E-post",
            },
        },
        onlineLinksCard: {
            websiteInput: {
                label: "Hemsida",
            },
            fbPageInput: {
                label: "Facebook sida",
            },
            igPageInput: {
                label: "Instagram-sida",
            },
        },
        saveBtn: "Spara",
    },
    locationsTab: {
        allLocationsSection: {
            title: "Platser",
            description: "Hantera flera platser för ditt företag.",
            createPlaceBtn: "Lägg till en ny plats",
        },
        selectedPlaceSection: {
            dropdown: {
                toggleBtn: "Alternativ",
                editBtn: "Redigera platsinformation",
                deleteBtn: "Radera plats",
            },
            detailsCard: {
                title: "Platsinformation",
                editBtn: "Redigera",
                emailLabel: "Plats e-postadress",
                phoneLabel: "Plats kontaktnummer",
            },
            categoryCard: {
                title: "Affärskategori",
                editBtn: "Redigera",
                mainCategoryLabel: "Main",
                additionalCategoryLabel: "Ytterligare",
                addBtn: "+ Lägg till",
            },
            openingHoursCard: {
                title: "Öppettider",
                editBtn: "Redigera",
                closedLabel: "Stängd",
            },
            photosCard: {
                title: "Mina foton",
                editBtn: "Redigera",
                label: "Visa ditt arbete",
                description:
                    "Inkludera bilder av ditt arbete (före / efter), team, arbetsplats eller utrustning",
            },
            mobileButtons: {
                editBtn: "Redigera platsinformation",
                deleteBtn: "Radera plats",
                closeBtn: "Stänga",
            },
        },
    },
    billingTab: {
        planCard: {
            title: "Planen",
            planName: "Team",
            priceDescription: "/anv/mån",
            planInfo: "faktureras årligen",
            changePlanBtn: "Ändra plan",
        },
        paymentMethodCard: {
            title: "Betalningsmetod",
            addBtn: "+ Lägg till",
            expireLabel: "Går ut den",
        },
        billingHistoryCard: {
            title: "Faktureringshistorik",
            table: {
                columns: {
                    date: "Datum",
                    description: "Beskrivning",
                    amount: "Belopp",
                },
                viewBtn: "Visa kvitto",
            },
        },
    },
    profile: {
        title: "Profil",
        saveBtn: "Spara",
        guide: {
            personalDetails: {
                title: "Personliga detaljer",
                description:
                    "Ange namn och kontaktinformation. E-postadressen här används för din inloggningsåtkomst.",
            },
            changePassword: {
                title: "ändra lösenord",
                description:
                    "För att göra en uppdatering, ange ditt befintliga lösenord följt av ett nytt. Om du inte känner till ditt befintliga lösenord loggar du ut och använder länken Återställ lösenord på inloggningssidan.",
            },
            notificationSettings: {
                title: "Mina aviseringar inställningar",
                description: "Få meddelanden om viktig aktivitet i ditt konto",
            },
        },
        personalDetailsCard: {
            uploadAvatarBtn: "Ladda upp profilbild",
            firstNameInput: {
                label: "Förnamn",
            },
            lastNameInput: {
                label: "Efternamn",
            },
            phoneInput: {
                label: "Telefonnummer",
            },
            emailInput: {
                label: "E-post",
            },
            currentPasswordInput: {
                label: "Nuvarande lösenord",
            },
            newPasswordInput: {
                label: "Nytt lösenord",
            },
        },
        notificationsCard: {
            notifyMeInput: {
                label: "Meddela mig om",
                options: {
                    allStaff: "Möten bokas med all personal",
                    meOnly: "Möten bokade endast med mig",
                },
            },
            bookedInput: {
                label: "Bokat på",
                allLocationsLabel: "Alla platser",
                changeBtn: "Förändra",
                newAppointmentsLabel: "Nya möten",
                cancellationLabel: "Avbokningar",
            },
        },
        croperModal: {
            title: "Beskära bild",
            saveBtn: "Tillämpa",
        },
        locationsModal: {
            title: "Välj platser",
            allPlacesLabel: "Välj alla",
            saveBtn: "Välj",
        },
    },
    locationInput: {
        title: "Affärsplats",
        label: "Var ligger ditt företag?",
    },
    cancelAppointmentModal: {
        title: "Avbryt bokningen",
        messageInput: {
            label: "Meddelande",
            description: "(frivillig)",
        },
        submitBtn: "Avbryt",
    },
    placeFormModal: {
        previousStepBtn: "Tidigare",
        nextStepBtn: "Nästa steg",
        saveBtn: "Spara",
        stepLabel: "Steg",
        stepOfLabel: "av",
        createPlaceMode: {
            step1: {
                title: "Om ditt företag",
            },
            step2: {
                title: "Välj din huvudkategori",
            },
            step3: {
                title: "Välj sekundära affärskategorier",
                description:
                    "Om ditt företag kan beskrivas av fler typer, välj alla som gäller",
            },
            step4: {
                title: "Lägg till din plats",
            },
        },
        editInfoMode: {
            title: "Om ditt företag",
        },
        editCategoriesMode: {
            step1: {
                title: "Välj din huvudkategori",
            },
            step2: {
                title: "Välj sekundära affärskategorier",
                description:
                    "Om ditt företag kan beskrivas av fler typer, välj alla som gäller",
            },
        },
        basicInfoCard: {
            title: "Grunderna",
            logoInput: {
                label: "Ladda upp logotyp (valfritt)",
                description:
                    "Det här fotot kommer att visas på din profilsida.",
                invalidType: "Välj en JPEG-, PNG- eller WebP-bild.",
                fileTooLarge: "Bilden får vara högst 2 MB.",
            },
            nameInput: {
                label: "Företagsnamn",
                description: "(visas på profilsidan)",
            },
            publicProfileInput: {
                label: "Länk till offentlig profil",
            },
            phoneInput: {
                label: "Plats kontaktnummer",
            },
            emailInput: {
                label: "Plats e-postadress",
            },
            descriptionInput: {
                label: "Om oss",
            },
            maxReservationInput: {
                label: "Maximalt antal bokade tjänster",
                description: "(antal tjänster i en tidslucka)",
                shortDescription: "per tidslucka",
            },
        },
    },
    placeImagesModal: {
        title: "Mina foton",
        card: {
            title: "Ladda upp foton",
        },
        saveBtn: "Spara",
    },
    availabilityInput: {
        title: "Tillgänglighet",
        closedLabel: "Stängd",
        addBtn: "+ Lägg till",
        saveBtn: "Spara",
    },
    openingHoursForm: {
        title: "Öppettider",
        closedLabel: "Stängd",
        saveBtn: "Spara",
    },
    mobileClientSelect: {
        title: "Välj kund",
        searchPlaceholder: "Sök efter kund",
    },
    mobileServiceSelect: {
        title: "Välj Service",
        searchPlaceholder: "Sök efter tjänstnamn",
    },
    weekdays: {
        monday: "Måndag",
        tuesday: "Tisdag",
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Fredag",
        saturday: "Lördag",
        sunday: "Söndag",
    },
    changeLanguageModal: {
        title: "Ändra språk",
        languageInput: {
            label: "Välj språk",
        },
        saveBtn: "Spara",
    },
    defaults: {
        checkboxGroup: {
            chooseAllLabel: "Välj alla",
        },
        select: {
            placeholder: "Välj alternativ",
            searchPlaceholder: "Sök",
            noOptionsText: "Inga tillgängliga alternativ",
        },
        dropdown: {
            toggleText: "Växla rullgardinsmenyn",
            description: "Placera dina föremål här",
        },
    },
};
